export class AccessHistory {
    Id: number;
    CRMNumber: string;
    JiraNumber: string;
    Description: string;
    Type: string;
    AddedBy: string;
    AddedOn: Date;
    IsAdminLogin: boolean;
}


export class LoginAudit{
    strKey: string;
    strValue: boolean;
}